import * as React from 'react';
import styles from './Feature.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DeluxeContext, DeluxeActionButton } from '../';
import { Title } from '../../title';
import { featuresList } from './FeaturesList';

export const Feature = () => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection }) => {
        const { feature } = currentSelection;
        const selectedFeature = featuresList.find(item => item.title === feature);
        return (
          <>
            <Title Tag='h1'>
              {selectedFeature.title}
            </Title>
            <div className={styles.feature}>
              <div>
                <p dangerouslySetInnerHTML={{ __html: selectedFeature.content }} />            
                <br /> 
                <DeluxeActionButton back />
              </div>
              <div>
                <FontAwesomeIcon icon={selectedFeature.icon} className={styles.icon} />
              </div>
            </div>
          </>
        );
      }}
    </DeluxeContext.Consumer>
  );
};